import { useNavigate } from '@tanstack/react-router';
import { Button, Result } from 'antd';
import { useTranslation } from 'react-i18next';

export const Route = createFileRoute({
  component: NotFound,
});

function NotFound() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Result
      status="404"
      title="404"
      subTitle={t('exception.404.subTitle')}
      extra={
        <Button type="primary" onClick={() => navigate({ to: '/arc' })}>
          {t('common.backHome')}
        </Button>
      }
    />
  );
}
